import { useFreshchat } from '@margex/ui'

import Cookies from 'js-cookie'
import { useFreshchatRestoreIdMutation } from '../../mutations'

export const useFreshchatLanding = () => {
  const { mutate } = useFreshchatRestoreIdMutation()

  useFreshchat({
    restoreId: Cookies.get('app_user_freshchat_restoreId'),
    externalId: Cookies.get('app_user_email'),
    setRestoreId: restoreId => mutate(restoreId),
    hideChatButton: false,
  })

  return null
}
